<template>
    <div>
        <div class="chatbot-widget__header chatbot-widget__fixed">
            <div class="chatbot-widget__header__left justify-content-center">
                <div class="header-icon back-icon" @click.stop="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                    <path d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </div>
                <span>{{ campaign.display_name }} Support</span>
                <div class="header-icon close-icon d-flex d-sm-none" @click.stop="closeChatbot">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M13.5 13.5L1.5 1.5M13.5 1.5L1.5 13.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div v-if="showResizeIcon" class="header-icon resize-icon d-flex d-sm-none" @click.stop="toggleExpand">
                  <svg v-if="isExpanded" width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.0123 9.98771C19.2775 9.98771 19.5319 9.88235 19.7194 9.69482C19.9069 9.50728 20.0123 9.25293 20.0123 8.98771C20.0123 8.7225 19.9069 8.46814 19.7194 8.2806C19.5319 8.09307 19.2775 7.98771 19.0123 7.98771H17.4263L21.7193 3.69471C21.9014 3.50611 22.0022 3.25351 22 2.99131C21.9977 2.72911 21.8925 2.4783 21.7071 2.29289C21.5217 2.10748 21.2709 2.00232 21.0087 2.00004C20.7465 1.99776 20.4939 2.09855 20.3053 2.28071L16.0123 6.57371V4.98771C16.0123 4.7225 15.9069 4.46814 15.7194 4.28061C15.5319 4.09307 15.2775 3.98771 15.0123 3.98771C14.7471 3.98771 14.4927 4.09307 14.3052 4.28061C14.1176 4.46814 14.0123 4.7225 14.0123 4.98771V8.98771C14.0123 9.25293 14.1176 9.50728 14.3052 9.69482C14.4927 9.88235 14.7471 9.98771 15.0123 9.98771H19.0123ZM7.98771 17.4263V19.0123C7.98771 19.2775 8.09307 19.5319 8.2806 19.7194C8.46814 19.9069 8.7225 20.0123 8.98771 20.0123C9.25293 20.0123 9.50728 19.9069 9.69482 19.7194C9.88235 19.5319 9.98771 19.2775 9.98771 19.0123V15.0123C9.98771 14.7471 9.88235 14.4927 9.69482 14.3052C9.50728 14.1176 9.25293 14.0123 8.98771 14.0123H4.98771C4.7225 14.0123 4.46814 14.1176 4.28061 14.3052C4.09307 14.4927 3.98771 14.7471 3.98771 15.0123C3.98771 15.2775 4.09307 15.5319 4.28061 15.7194C4.46814 15.9069 4.7225 16.0123 4.98771 16.0123H6.57371L2.28071 20.3053C2.09855 20.4939 1.99776 20.7465 2.00004 21.0087C2.00232 21.2709 2.10748 21.5217 2.29289 21.7071C2.4783 21.8925 2.72911 21.9977 2.99131 22C3.25351 22.0022 3.50611 21.9014 3.69471 21.7193L7.98771 17.4263Z" fill="white" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2C16.7348 2 16.4804 2.10536 16.2929 2.29289C16.1054 2.48043 16 2.73478 16 3C16 3.26522 16.1054 3.51957 16.2929 3.70711C16.4804 3.89464 16.7348 4 17 4H18.586L14.293 8.293C14.1108 8.4816 14.01 8.7342 14.0123 8.9964C14.0146 9.2586 14.1198 9.50941 14.3052 9.69482C14.4906 9.88023 14.7414 9.9854 15.0036 9.98767C15.2658 9.98995 15.5184 9.88916 15.707 9.707L20 5.414V7C20 7.26522 20.1054 7.51957 20.2929 7.70711C20.4804 7.89464 20.7348 8 21 8C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2H17ZM4 18.586V17C4 16.7348 3.89464 16.4804 3.70711 16.2929C3.51957 16.1054 3.26522 16 3 16C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H7C7.26522 22 7.51957 21.8946 7.70711 21.7071C7.89464 21.5196 8 21.2652 8 21C8 20.7348 7.89464 20.4804 7.70711 20.2929C7.51957 20.1054 7.26522 20 7 20H5.414L9.707 15.707C9.88916 15.5184 9.98995 15.2658 9.98767 15.0036C9.9854 14.7414 9.88023 14.4906 9.69482 14.3052C9.50941 14.1198 9.2586 14.0146 8.9964 14.0123C8.7342 14.01 8.4816 14.1108 8.293 14.293L4 18.586Z" fill="white" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
            </div>
        </div>
        <div class="header-spacer"></div>
    </div>
  </template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ChatbotEmbedHeader',
  data() {
    return {
      isExpanded: true,
      showResizeIcon: false
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.campaign
    })
  },
  methods: {
    goBack() {
      this.$router.replace({ name: 'chatbot-embed', query: { openChat: 'true' } })
      window.parent.postMessage('chatWidgetCollapsed', '*')
    },
    closeChatbot() {
      window.parent.postMessage('chatWidgetClosed', '*')
      setTimeout(() => {
        this.$router.replace({ name: 'chatbot-embed', query: { openChat: 'false' } })
      }, 300)
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      window.parent.postMessage(this.isExpanded ? 'chatWidgetExpanded' : 'chatWidgetCollapsed', '*')
    }
  },
  mounted() {
    window.parent.postMessage('internalQuickLinkOpened', '*')

    this.messageHandler = (event) => {
      if (event.data === 'showResizeButton') {
        window.parent.postMessage('chatWidgetExpanded', '*')
        this.showResizeIcon = true
      } else if (event.data === 'hideResizeButton') {
        this.showResizeIcon = false
      }
    }

    window.addEventListener('message', this.messageHandler)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageHandler)
  }
}
</script>

  <style scoped lang="less">
  .chatbot-widget__header {
    min-height: 64px;
    display: flex;
    flex-shrink: 0;
    padding: 15px;
    align-items: center;
    justify-content: space-between;
    color: #FFFFFF;
    z-index: 6;
    background: var(--theme_color);
    position: fixed;
    width: 100%;
  }

  .chatbot-widget__fixed {
    left: 0;
    right: 0;
    width: 100%;
    padding: 20px;
    position: fixed;
  }

  .chatbot-widget__header__left {
    display: flex;
    align-items: center;
    gap: 15px;
    flex: 1 0 0;
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }

  .justify-content-center {
    justify-content: center;
  }

  .header-icon {
    display: flex;
    width: 35px;
    height: 35px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 40px;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.10);
    position: absolute;
    left: 20px;

    &.close-icon {
      right: 20px;
      left: auto;
    }
    &.resize-icon {
      right: 65px;
      left: auto;
    }
  }

  .header-icon:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  .header-spacer {
    height: 65px;
  }
  </style>
